import React from 'react'
import { Column } from '@/components/BsrsGrid'
import {
  formatArabicAddressDto,
  formatLatinAddressDto
} from '@/utils/addressFormatter'

export default ({ dataField, locale, ...props }) => {
  const cell = ({ dataItem }) => <td>{locale === 'en' ? formatLatinAddressDto(dataItem[dataField]) : formatArabicAddressDto(dataItem[dataField])}</td>
  const cellExport = ({ dataItem }) => {
    return locale === 'en' ? formatLatinAddressDto(dataItem[dataField]) : formatArabicAddressDto(dataItem[dataField])
  }

  return <Column cell={cell} cellExport={cellExport} {...props} />
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/BsrsGrid.AddressColumn.js